import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  Link,
  CircularProgress
} from "@mui/material";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import Header from "../components/Navbar";
import Footer from "../components/Footer";
import loginBI from "../assets/Images/login-bc.png";
import { postData } from "../services/Request";

const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)

    const payload = {
      email: email,
      password: password,
    };
    try {
      const response = await postData("api/auth/login", payload)
      
      if (response.status === true && response.user.status == true) {
        toast.success("Login successful!");
        // Save user data in localStorage
        localStorage.setItem("user", JSON.stringify(response.user));
        localStorage.setItem("token", response.token);
        // Redirect to BasicSearch
        navigate("/BasicSearch");
        setLoading(false)
      } else if (response.status === true && response.user.status == 0) {
        toast.error("Your account is not active");
        setLoading(false)
      }else {
        toast.error(response.message || "Invalid email or password");
        setLoading(false)
      }
    } catch (err) {
      toast.error("Invalid email or password");
      setLoading(false)
    }
  };
  

  return (
    <>
      <Header />

      {/* Full Page Background */}
      <Box
        sx={{
          backgroundImage: `url(${loginBI})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
          px: 2,
          backgroundColor: "#7d9368",
          height: '80vh'
        }}
      >
        <Container maxWidth="sm">
          {/* Glass Effect Form */}
          <Paper
            elevation={8}
            sx={{
              p: { xs: 3, sm: 5 },
              borderRadius: 4,
              backdropFilter: "blur(16px)",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              boxShadow: "0px 8px 30px rgba(0,0,0,0.3)",
            }}
          >
            {/* Heading */}
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                mb: 1,
                textAlign: "center",
                color: "#2f3e46",
              }}
            >
              Log into Account
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#4f5d63",
                mb: 4,
                textAlign: "center",
              }}
            >
              Please log in to your account to continue.
            </Typography>

            
            {/* Form */}
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <TextField
                label="Email"
                type="email"
                variant="outlined"
                fullWidth
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                label="Password"
                type="password"
                variant="outlined"
                fullWidth
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <Button
                type="submit"
                variant="contained"
                size="large"
                fullWidth
                sx={{
                  mt: 2,
                  background: "linear-gradient(90deg, #a1c97b, #8bbd5d)",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  textTransform: "none",
                  fontSize: "16px",
                  "&:hover": {
                    background: "linear-gradient(90deg, #8bbd5d, #6fa644)",
                  },
                }}
              >
                {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Login"}
              </Button>

              {/* Link to Signup */}
              <Typography
                variant="body2"
                sx={{ textAlign: "center", mt: 2, color: "gray" }}
              >
                New account?{" "}
                <Link
                  href="/signup"
                  sx={{
                    color: "#8bbd5d",
                    fontWeight: "bold",
                    textDecoration: "none",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  Register
                </Link>
              </Typography>
            </Box>
          </Paper>
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default LoginPage;
